const TIME_FORMATTER = new Intl.DateTimeFormat("fr-FR", {
  hour: "2-digit",
  minute: "2-digit",
});

export function isPlainObject(value) {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function normalizeText(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function toNumber(value, fallback = 0) {
  const numericValue = Number(value);

  return Number.isFinite(numericValue) ? numericValue : fallback;
}

export function formatTonnage(value) {
  const numericValue = toNumber(value, 0);

  return Number.isInteger(numericValue)
    ? String(numericValue)
    : numericValue.toFixed(1).replace(/\.0$/, "");
}

export function formatDecimal(value, digits = 1) {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return null;
  }

  return Number.isInteger(numericValue)
    ? String(numericValue)
    : numericValue.toFixed(digits).replace(/\.0$/, "");
}

export function formatClockValue(value) {
  if (value === null || value === undefined) {
    return "";
  }

  const text = String(value).trim();
  if (!text) {
    return "";
  }

  const directClockMatch = text.match(/^(\d{1,2}):(\d{2})/);
  if (directClockMatch) {
    return `${directClockMatch[1].padStart(2, "0")}:${directClockMatch[2]}`;
  }

  const parsedDate = new Date(text);
  if (!Number.isNaN(parsedDate.getTime())) {
    return TIME_FORMATTER.format(parsedDate);
  }

  return text;
}

export function sortText(left, right) {
  return left.localeCompare(right, "fr", { sensitivity: "base" });
}